import { ControllerDto } from 'src/Libs/flow/installation/api'
import { getIoPairingId } from '../../../parsers/device-parsers/get-device-pairing-id'
import { HeatpumpIo } from 'src/Libs/flow/installation/forms'
import { parseControllerDevice } from '../../../parsers/device-parsers/device-parsers'

/** Dto to form HeatpumpIo */
export const fromHeatpumpDtoToModel = (io: Nullable<ControllerDto>): HeatpumpIo => {
  return {
    ...parseControllerDevice(io),

    nominalPower: io.parameters?.nominalPower ?? 0,
    initialPairingId: getIoPairingId(io),
  }
}
